import axios from '../../utils/axios';
import { objectToFormData } from '../utils';
import { formatLocalDateAsUtcMidnight } from '../../utils/formatTime';

// GET
// /Api/Budget/BudgetData
export const getBudgetData = async () => {
  const response = await axios.get('/Budget/BudgetData');
  return response;
};

// POST
// /Api/Budget/CreateGLCode glCode facilityId
export const postCreateGLCode = async (glCode, facilityBookingId) => {
  const response = await axios.post(`/Budget/CreateGLCode?glCode=${glCode}&facilityBookingId=${facilityBookingId}`);
  return response;
};

// POST
// /Api/Budget/DeleteGLCode ids
export const postDeleteGLCodes = async (ids) => {
  const response = await axios.post(`/Budget/DeleteGLCodes`, objectToFormData({ ids }));
  return response;
};

// POST
// /Api/Budget/DeleteBudget id
export const postDeleteBudget = async (ids) => {
  const response = await axios.post(`/Budget/DeleteBudgets`, objectToFormData({ ids }));
  return response;
};

// GET
// /Api/Budget/GetFacilityBudgetCategories facilityId
export const getFacilityBudgetCategories = async (facilityId, date) => {
  const response = await axios.get(`/Budget/GetFacilityBudgetCategories?facilityId=${facilityId}&date=${formatLocalDateAsUtcMidnight(date)}`);
  return response;
};


// GET
// /Api/Budget/DownloadBudgets
//Download Api is used in code bec we need the `${HOST_API_URL}

// POST
// /Api/Budget/CopyBudget facilityId-int facilityCopyId-int useGLs-boolean agoraCategoryIds-[]
export const postCopyBudget = async (facilityIds, facilityCopyId, facilityCopyGLId, agoraCategoryIds) => {
  const updatedForm = {
    facilityIds: facilityIds.map((facility) => facility.id),
    facilityCopyId,
    facilityCopyGLId,
    agoraCategoryIds: agoraCategoryIds.map((item) => item.id)
  };

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Budget/CopyBudget', formData);
  return response;
};


export const postCopyBudgetMultiple = async (facilityIds, facilityCopyId, useGLs, agoraCategoryIds) => {
  const updatedForm = {
    facilityIds,
    facilityCopyId,
    useGLs,
    agoraCategoryIds: agoraCategoryIds.map((item) => item.id),
  };

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Budget/CopyBudgetMultiple', formData);
  return response;
};

//Post
// /Api/Budget/BudgetForm Id PPDBudget MidBudgetCategoryId AgoraSubcategoryId ExcludeFromMain
export const postBudgetForm = async (form, id) => {
  const updatedForm = {
    PPDBudget: form.ppdBudget,
    FacilityId: form.facility.id,
    AgoraCategoryId: form.agoraCategory.id,
    AgoraSubcategoryId: form.agoraSubcategory.id,
    ExcludeFromMain: form.excludeFromMain,
    FlatRate: form.flatRate,
    GLId: form.glCode.id,
  };

  if (id) {
    updatedForm.Id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Budget/BudgetForm', formData);
  return response;
};
